import React from 'react';
import { Search } from 'lucide-react';

interface WorkoutSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function WorkoutSearch({ value, onChange }: WorkoutSearchProps) {
  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search workouts..."
        className="w-full bg-muted/50 border border-border/50 rounded-lg pl-10 pr-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
    </div>
  );
}